import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import LoadingPane from "controls/loadingPane";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import ChargeTypeSelectViewModel from "viewModels/common/chargeTypeSelectViewModel";
import { registerView, View, ViewComponent } from "@frui.ts/views";
import ChargeTypeViewModel from "viewModels/eshop/order/components/chargeViewModel";

export const ChargeTypeSelectView: ViewComponent<ChargeTypeSelectViewModel> = observer(({ vm }) => {
  const vignetteLabel = vm.localizationService.translateAttribute("orderItem", "chargeType");

  const chargeScreenReaderLabel = (chargeTypeViewModel: ChargeTypeViewModel) =>
    `${vignetteLabel}: ${chargeTypeViewModel.description} – ${chargeTypeViewModel.price}`;

  // If multiEshop, we need to distinguish batch indexes to prevent displaying items with the same ID.
  if (vm.batchIndex) {
    vm.chargeTypeViewModels.forEach((x: ChargeTypeViewModel) => {
      x.batchIndex = vm.batchIndex;
    });
  }

  return (
    <fieldset className="form-row mb-4">
      <Form.Group as={Col} xs={12} className="m-0">
        {vm.showLabel && <legend className="font-weight-bold font-size-sm m-0">{vignetteLabel}</legend>}
        <LoaderOverlay loading={!vm.isInitialized} loader={<LoadingPane />}>
          <Form.Row className={"align-items-center" + (vm.chargeTypeError !== undefined ? " is-invalid" : "")}>
            {vm.chargeTypeViewModels.map((chargeTypeViewModel) => (
              <Form.Group
                controlId={chargeTypeViewModel.chargeTypeCode}
                as={Col}
                key={chargeTypeViewModel.chargeType.id}
                sm={12}
                xl={6}
                className="mb-0 pl-2 pr-2">
                <Form.Label className="screenreader">{chargeScreenReaderLabel(chargeTypeViewModel)}</Form.Label>
                <View vm={chargeTypeViewModel} />
              </Form.Group>
            ))}
          </Form.Row>
          {vm.chargeTypeError && (
            <Form.Control.Feedback type="invalid">
              {vm.localizationService.translateAttribute("orderItem", "chargeTypeId.required")}
            </Form.Control.Feedback>
          )}
        </LoaderOverlay>
      </Form.Group>
    </fieldset>
  );
});

registerView(ChargeTypeSelectView, ChargeTypeSelectViewModel);
